import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslocoService } from '@jsverse/transloco';
import { NotificationCenterService } from './notification-center.service';

/** Key of the app-wide <p-toast> in app.component.html; pages with their own toast are not affected. */
export const APP_TOAST_KEY = 'app';

@Injectable({
  providedIn: 'root'
})
export class SuccessNotificationService {
  private messageService = inject(MessageService);
  private translocoservice = inject(TranslocoService);
  private notificationCenter = inject(NotificationCenterService);


  // in order to work with transloco pls call this method with the corresponding translation key.
  displaySuccessionMsg(msg: string): void {
    const translatedMessage = this.translocoservice.translate(msg);
    this.notificationCenter.push('success', translatedMessage);
    this.messageService.add({ key: APP_TOAST_KEY, severity: 'success', detail: translatedMessage, life: 8000 });
  }

  // Display error message with translation key
  displayErrorMsg(msg: string): void {
    const translatedMessage = this.translocoservice.translate(msg);
    this.notificationCenter.push('error', translatedMessage);
    this.messageService.add({ key: APP_TOAST_KEY, severity: 'error', detail: translatedMessage, life: 8000 });
  }
}
